import { GET_RESE_USER_TABLE_DATA, GET_RESE_USER_TABLE_DIVISION,GET_RESE_USER_TABLE_STORE, GET_RESE_USER_TABLE_BANNER, GET_RESE_USER_TABLE_CITY,
GET_RESE_USER_TABLE_STATE, GET_RESE_USER_TABLE_STATUS, UPDATE_RESE_USER_TABLE_DATA } from "./actionTypes";

const initialState = {
    reseUserTableData: [],
    reseUserTableDivisionData: [],
    reseUserTableStoreData: [],
    reseUserTableBannerData: [],
    reseUserTableCityData: [],
    reseUserTableStateData: [],
    reseUserTableStatusData: [],
    totalRecords: 0,
    updateSuccess: false,
    updateError: null
}

const reseUserReducer = (state = initialState, action={type: "", payload:null}) => {
    switch(action.type) {
        case GET_RESE_USER_TABLE_DATA.SUCCESS:
            let { userDivisionStoreList, totalRecords } = action.payload.data;
            return {
                ...state,
                reseUserTableData:userDivisionStoreList,
                totalRecords:totalRecords,
                updateSuccess: false,
                updateError: null

            }
        
        case UPDATE_RESE_USER_TABLE_DATA.SUCCESS:
            return {
                ...state,
                updateSuccess: true,
                updateError: null
            }   

         case UPDATE_RESE_USER_TABLE_DATA.ERROR:
                return {
                    ...state,
                    updateSuccess: false,
                    updateError: action.payload
                }      

        case GET_RESE_USER_TABLE_DIVISION.SUCCESS:
            return {
                ...state,
                reseUserTableDivisionData: action.payload
            }
        case GET_RESE_USER_TABLE_STORE.SUCCESS:
            return {
                ...state,
                reseUserTableStoreData: action.payload
            }
        case GET_RESE_USER_TABLE_BANNER.SUCCESS:
            return {
                ...state,
                reseUserTableBannerData: action.payload
            }
        case GET_RESE_USER_TABLE_CITY.SUCCESS:
            return {
                ...state,
                reseUserTableCityData: action.payload
            }
        case GET_RESE_USER_TABLE_STATE.SUCCESS:
            return {
                ...state,
                reseUserTableStateData: action.payload
            }
        case GET_RESE_USER_TABLE_STATUS.SUCCESS:
            return {
                ...state,
                reseUserTableStatusData: action.payload
            }
        default:
            return state;
    }
}

export default reseUserReducer;